class Localization {
  private refs: {
    form: HTMLFormElement | null;
    languageInput: HTMLSelectElement | null;
  };

  constructor() {
    this.refs = {
      form: null,
      languageInput: null,
    };
    this.init();
  }

  init(): void {
    this.refs.form = document.querySelector('[ref="localizationForm"]') as HTMLFormElement;
    this.refs.languageInput = document.querySelector('[ref="languageInput"]') as HTMLSelectElement;

    if (this.refs.languageInput) {
      this.refs.languageInput.addEventListener('change', this.changeLanguage.bind(this));
    }
  }

  changeLanguage(event: Event): void {
    const { form, languageInput } = this.refs;
    const target = event.target as HTMLSelectElement;
    const value = target?.value;

    if (value && form && languageInput) {
      languageInput.value = value;
      form.submit();
    }
  }
}

export default Localization;
